export default function getTable(editor, tableId) {
  var cells = editor.getTableCells(tableId);
  if (cells.isEmpty()) return undefined;
  return editor.value.document.getParent(cells.first().key);
}